import type { WidgetPreset } from "../types";
import templateHtml from "./template.html?raw";

export const EARTH_MOON: WidgetPreset = {
  id: "earth-moon-orbit",
  label: "Earth & Moon 🌍",
  defaultWidth: 280,
  defaultHeight: 280,
  html: templateHtml,
};
